import { createFileRoute } from "@tanstack/react-router";
import { ServiceLayout } from "@/components/ServiceLayout";
import { img } from "@/lib/images";
import { canonicalLinks, routeMeta } from "@/lib/seo";

export const Route = createFileRoute("/services/payroll")({
  head: () => ({
    meta: [
      ...routeMeta("/services/payroll"),
      { title: "Payroll Services in Winter Garden | CCOB & Company" },
      { name: "description", content: "Reliable payroll processing, tax filings, and direct deposit for Florida small businesses. Quarterly 941s, annual W-2s, and full compliance." },
      { property: "og:title", content: "Payroll Services — CCOB And Company PA" },
      { property: "og:description", content: "Full-service payroll, tax filings, and compliance handled for you." },
    ],
    links: canonicalLinks("/services/payroll"),
  }),
  component: () => (
    <ServiceLayout
      eyebrow="Payroll"
      title="Payroll Done Right — Every Pay Period"
      subtitle="Accurate paychecks. Filed taxes. Zero IRS letters."
      hero={img.heroAccounting}
      image={img.payroll}
      intro="Payroll mistakes are expensive — in penalties, in employee trust, in your time. We handle the whole cycle: paychecks, direct deposits, withholdings, federal and state filings, and year-end W-2s and 1099s."
      items={[
        { title: "Payroll Processing", desc: "Weekly, bi-weekly, semi-monthly, or monthly — your team gets paid on time, every time." },
        { title: "Direct Deposit & Pay Stubs", desc: "Secure direct deposit for employees plus digital pay stubs they can access anytime." },
        { title: "Tax Withholding & Deposits", desc: "Federal, state, Social Security, and Medicare — calculated, deposited, and reconciled." },
        { title: "Quarterly & Annual Filings", desc: "941, 940, RT-6, W-2, W-3, and 1099 filings — prepared and submitted on schedule." },
        { title: "New Hire Reporting", desc: "Florida new-hire reports filed automatically when you bring someone on." },
        { title: "Workers' Comp Audit Support", desc: "Reports and documentation ready when your insurance audit shows up." },
      ]}
    />
  ),
});
